export const PermissionEvaluations = {
    GET: "mgr-products-evaluations-GET",
    GET_UUID: "mgr-products-evaluations-**-GET",
    PUT: "mgr-products-evaluations-**-PATCH"
};